import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { Constants } from '../../helper/constants';
import { LetterService } from '../../services/letter.service';
import { PcnBlockService } from '../../services/pcn-block.service';
import { GlobalObservables } from '../../../../app.global.observer';
import { Global } from '../../../../app.global';
import { ChangeDecisionModel } from '../../viewmodels/change-decision.model';
import { PcnConst } from '../../helper/pcnConst';
import { DecisionsConst } from '../../helper/decisionsConst';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'change-decision',
  templateUrl: './change-decision.component.html',
  styleUrls: ['./change-decision.component.scss'],
})
export class ChangeDecisionComponent implements OnInit {
  @Input() decision: string = this.decisionsConst.upheld.id;
  @Output() changeDecision: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();

  public constants = Constants;
  decisionReasons: any;
  cancelOptions: any;
  challenge: any;
  decisionDetails = '';
  infoDetails = '';
  decisionModel = new ChangeDecisionModel();

  constructor(
    public globalObs: GlobalObservables,
    public global: Global,
    private modalService: NgbModal,
    private letterService: LetterService,
    private pcnService: PcnBlockService,
    public pcnConst: PcnConst,
    public decisionsConst: DecisionsConst
  ) {}

  ngOnInit() {
    this.setDecisionReasons();
    this.setCancelOptions();
    this.setChallengeOptions();
  }

  setDecisionReasons() {
    this.decisionReasons = {
      optionSelected: 1,
      optionList: [
        {
          id: 1,
          caption: 'Mitigating circumstances',
        },
        {
          id: 2,
          caption: 'PCN issued incorrectly',
        },
        {
          id: 3,
          caption: 'RM policy wrong',
        },
        {
          id: 4,
          caption: 'Discretion',
        },
        {
          id: 5,
          caption: 'Others',
        },
      ],
    };
  }

  setCancelOptions() {
    this.cancelOptions = {
      optionSelected: 2,
      optionList: [
        {
          id: 0,
          caption: 'Error',
        },
        {
          id: 1,
          caption: 'Goodwill',
        },
        {
          id: 2,
          caption: 'Other',
        },
      ],
    };
  }

  setChallengeOptions() {
    this.challenge = {
      optionSelected: 1,
      optionList: [
        {
          id: 0,
          caption: 'Yes',
        },
        {
          id: 1,
          caption: 'No',
        },
      ],
    };
  }

  getDecisionText() {
    if (this.decision === 'upheld') {
      return 'Upheld';
    } else if (this.decision === 'cancel') {
      return 'Cancel';
    }
    return 'Req Info';
  }

  isPcnStageCCSent() {
    return this.global.PCN.selectedStageId === parseInt(this.pcnConst.stageCCSent, 10);
  }

  isPcnStageIdSmallerThanCCSent() {
    const pcnStage = this.global.PCN.selectedStageId;

    const stageObject = this.global.PCN.stages[this.global.PCN.selectedStageId];

    if (stageObject === undefined) {
      return false;
    } else {
      return stageObject.groupId === 1 || stageObject.groupId === 2 || stageObject.groupId === 3;
    }

    // return pcnStage !== this.pcnConst.stageCCSent &&
    //   pcnStage !== this.pcnConst.stageBailiffs &&
    //   pcnStage !== this.pcnConst.stageOFRSent;
  }

  changeDecisionStatus(decision) {
    this.decision = decision;
  }

  isChangeDecisionAllowed() {
    if (this.decision === this.decisionsConst.reqInfo.id && this.infoDetails.length < 5) {
      return false;
    }
    return this.decisionDetails.length >= 3;
  }

  submitChangeDecision() {
    if (!this.isChangeDecisionAllowed) {
      return;
    }
    this.decisionModel = {
      decisionId: this.getDecisionIdFromDescription(this.decision),
      reason: parseInt(this.decisionReasons.optionSelected, 10),
      details: this.decisionDetails,
      challengeOption: this.challenge.optionSelected,
      infoDetails: this.infoDetails,
      cancelOption: parseInt(this.cancelOptions.optionSelected, 10),
    };
    this.changeDecision.emit(this.decisionModel);
    console.log('submit change decision');
  }

  getDecisionIdFromDescription(decision) {
    if (decision !== undefined) {
      if (decision === this.decisionsConst.upheld.id) {
        return 1;
      } else if (decision === this.decisionsConst.reqInfo.id) {
        return 2;
      } else if (decision === this.decisionsConst.cancel.id) {
        return 3;
      }
      return 1;
    }
    return 1;
  }

  onCloseModal() {
    this.closeModal.emit();
  }
}
